import ApiBase from '../api-base'
import { PUBLIC } from '../constants'
export default class PublicUser extends ApiBase {
  constructor(store) {
    const path = `${PUBLIC}/account`
    super(store, path)
  }

  check(model, showProgress) {
    return this._request({
      action: 'check',
      method: 'POST',
      body: model,
      showProgress
    })
  }

  login(model, showProgress) {
    return this._request({
      action: 'login',
      method: 'POST',
      body: model,
      showProgress
    })
  }

  otpLogin(model, showProgress) {
    return this._request({
      action: 'otp/login',
      method: 'POST',
      body: model,
      showProgress
    })
  }

  otpPassword(model, showProgress) {
    return this._request({
      action: 'otp/password/old',
      method: 'PATCH',
      body: model,
      showProgress
    })
  }
}
